import { put } from 'redux-saga/effects';
// constants
import * as C from '../constants';
//////////////////////////////////////////////////

export const routesSagas = {
  [C.ROUTE_PATH_HOME]: function* homeSaga() {
    yield put({ type: C.VISIT_HOME_PAGE });
  },
  [C.ROUTE_PATH_LOGIN]: function* loginSaga() {
    yield put({ type: C.VISIT_LOGIN_PAGE });
  },
};
